import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSlidesTallAdd: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="slides-tall-add"><path d="M15.25 6.75V2.75H4.75V17.25H8.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M14 11.75V14M14 14V16.25M14 14H11.75M14 14H16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19.25 6.75H8.75V21.25H19.25V6.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSlidesTallAdd;
